import { useRouter } from 'next/router';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import eclipseItems from '@utils/eclipseItems';
import { emptyList } from '@constants/empty';

const useLanguages = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const languages = [];

  const { available_language = emptyList } = quizDetails;

  available_language.forEach((language) => {
    if (language.code !== -1) {
      languages.push(language.display_name);
    }
  });

  return {
    languages,
    formatedLanguages: languages.length ? `${eclipseItems(languages)}` : ''
  };
};

export default useLanguages;
